import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';
import {
AfterViewInit,
ChangeDetectionStrategy,
Component,
inject,
Inject,
Input,
OnDestroy,
ViewChild
} from '@angular/core';
import { FormControl,ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialog,MatLegacyDialogModule,MatLegacyDialogRef,MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import {
MatLegacyPaginator as MatPaginator,
MatLegacyPaginatorIntl as MatPaginatorIntl,
MatLegacyPaginatorModule as MatPaginatorModule
} from '@angular/material/legacy-paginator';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSort,MatSortModule } from '@angular/material/sort';
import { MatTable,MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Core } from '@pdftron/webviewer';
import { BehaviorSubject,combineLatest,firstValueFrom,Observable,of,switchMap } from 'rxjs';
import { map,shareReplay,startWith,take,takeUntil } from 'rxjs/operators';
import {
AccountsReceivableLedgerEntity,
AccountsReceivableLedgerTypeEnum,
ARLTypeEnumNames, financialRound
} from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { CommissionEntity } from '../../../dave-data-module/entities/commission.entity';
import { CustomerEntity } from '../../../dave-data-module/entities/customer.entity';
import {
    LedgerImportDocumentTypeNames,
    LedgerImportDocumentTypes, LedgerImportEntity, LedgerImportStatusEnum, LedgerImportStatusNames,
} from '../../../dave-data-module/entities/ledger-import.entity';
import { MaterialToSupplierEntity } from '../../../dave-data-module/entities/materialToSupplier.entity';
import { AccountsReceivableLedgerPostType } from '../../../dave-data-module/graphql-types';
import { ArlDataService } from '../../../dave-data-module/services/arl-data.service';
import { MaterialToSupplierDataService } from '../../../dave-data-module/services/material-to-supplier-data.service';
import { State } from '../../../dave-data-module/State';
import { LedgerImportActionTypes } from '../../../dave-data-module/State/actions/accounting.actions';
import { BaseActionTypes } from '../../../dave-data-module/State/actions/base.actions';
import { getCommissionById,getCommissions } from '../../../dave-data-module/State/selectors/commission.selector';
import { getLedgerImportById } from '../../../dave-data-module/State/selectors/ledger-import.selector';
import { DaveLoadingModule } from '../../../dave-loading/dave-loading.module';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../../../dave-utils-module/app-filter-module/app-filter.module';
import {
FilterOption,FILTER_TYPE_SEARCH_MULTI_SELECT,IFilterTypeSearchMultiSelectValue
} from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { SelectSearchOption } from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { SelectSearchModule } from '../../../dave-utils-module/select-search/select-search.module';
import { AllReportsMeta,ReportsPageMeta } from '../../../helper/page-metadata';
import { HintIconComponent } from '../../../hint-icon/hint-icon.component';
import { MatPaginatorWrapperComponent } from '../../../mat-paginator-wrapper/mat-paginator-wrapper.component';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { FilterTypes } from '../../../services/default-filter.service';
import { GermanPaginatorIntl } from '../../../services/german-paginator-intl.service';
import { LoadingService } from '../../../services/loading.service';
import { MaterialPriceDetailsPopupComponent,MaterialPriceDetailsPopupComponentDialogData,MaterialPriceDetailsPopupComponentDialogReturnData } from '../material-price-details-popup/material-price-details-popup.component';
import { NewOrderConfirmDialogComponent,NewOrderConfirmDialogData,NewOrderConfirmDialogPriceType,NewOrderConfirmDialogReturnData } from './new-order-confirm-dialog/new-order-confirm-dialog.component';
import { NewOrderFromLedgerimportDataSource,NewOrderFromLedgerimportItem } from './new-order-from-ledgerimport-datasource';
import onDateSelected = Core.onDateSelected;
import { CustomerDataService, CustomerSearchState, getCustomerOptionLabel, withOptionLabel } from '../../../dave-data-module/services/customer-data.service';
import {
    SelectSearchPagedOptionsComponent
} from '../../../dave-utils-module/select-search/components/select-search-paged-options/select-search-paged-options.component';

export interface NewOrderFromLedgerimportDialogData {
    arls: Array<Pick<AccountsReceivableLedgerEntity, 'Id' | 'MaterialId' | 'Type' | 'Quantity' | 'QuantityTypeId' | 'BookingText' | 'Information' | 'CostAmount' | 'Tax' | 'SupplierId'>>;
    rootLedgerImportId: number;
    commissionId: number | null;
    documentType: LedgerImportDocumentTypes.Order | LedgerImportDocumentTypes.DeliveryNote;
}
export type NewOrderFromLedgerimportDialogReturnData = undefined;

@Component({
    selector: 'app-new-order-from-ledgerimport',
    templateUrl: './new-order-from-ledgerimport.component.html',
    styleUrls: ['./new-order-from-ledgerimport.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatLegacyDialogModule,
        AppButtonModule,
        SelectSearchModule,
        ReactiveFormsModule,
        DaveLoadingModule,
        MatCheckboxModule,
        MatLegacyButtonModule,
        MatLegacyTooltipModule,
        FontAwesomeModule,
        HintIconComponent,
        MatLegacyInputModule,
        AppFilterModule,
        MatBadgeModule,
        MatPaginatorWrapperComponent,
        SelectSearchPagedOptionsComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: MatPaginatorIntl, useClass: GermanPaginatorIntl }],
})
export class NewOrderFromLedgerimportComponent implements AfterViewInit, OnDestroy {
    @ViewChild('paginator') paginator!: MatPaginator;

    public ArlFilterSettings$: Observable<FilterOption[]> = of(null).pipe(
        map(() => {
            let typeValues: IFilterTypeSearchMultiSelectValue<string>[] = Array.from(ARLTypeEnumNames, ([val, key]) => ({
                id: val,
                label: key,
            })).filter((v) => v.id !== AccountsReceivableLedgerTypeEnum.Group && v.id !== AccountsReceivableLedgerTypeEnum.Text);

            const ret: FilterOption[] = [
                {
                    Name: FilterTypes.ArlType,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Typ',
                    Icon: 'filter',
                    Values: typeValues,
                },
            ];
            return ret;
        }),
        startWith([]),
    );
    materialToSupplierDataService$ = inject(MaterialToSupplierDataService);

    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild(MatTable) table!: MatTable<NewOrderFromLedgerimportItem>;
    materialSelection = new SelectionModel<NewOrderFromLedgerimportItem>(true, [], true, (a, b) => a.id === b.id);
    dataSource: NewOrderFromLedgerimportDataSource;
    protected supplierForm = new FormControl<CustomerEntity | null>(null);
    protected commissionForm = new FormControl<CommissionEntity | null>(null);
    protected isAllSelected$: Observable<boolean>;
    protected liLabelNew = LedgerImportStatusNames.get(LedgerImportStatusEnum.Neu);
    protected liLabelShipped = LedgerImportStatusNames.get(LedgerImportStatusEnum.Versandt);
    protected liLabelBooked = LedgerImportStatusNames.get(LedgerImportStatusEnum.Gebucht);
    public HeaderMap = {
        Information: 'Bezeichnung',
        Quantity: 'Gesamtmenge (Soll)',
        quantityType: 'Einheit',
        costAmount: 'EK Preis',
        // alreadyOrderedQuantity:
    };
    public FilterAmount$: Observable<number>;
    protected displayedColumns: Array<keyof NewOrderFromLedgerimportItem | 'select'> = [
        'select',
        'bookingText$',
        'Information',
        'Quantity',
        'quantityForm',
        'quantityType',
        'costAmount',
        'costAmountFromMaterialToSupplierOrMaterial$',
        'supplierName$',
        'alreadyOrderedQuantityForCommissionNew$',
        'alreadyOrderedQuantityForCommissionShipped$',
        'alreadyOrderedQuantityForCommissionBooked$',
    ];
    protected displayedTextColumns = this.displayedColumns.filter(
        (c) =>
            ![
                'select',
                'supplierName$',
                'alreadyOrderedQuantityForCommissionNew$',
                'alreadyOrderedQuantityForCommissionShipped$',
                'alreadyOrderedQuantityForCommissionBooked$',
                'costAmountFromMaterialToSupplierOrMaterial$',
                'alreadyOrderedQuantityForCommission$',
                'bookingText$',
                'quantityForm',
            ].includes(c),
    );
    private arls$ = new BehaviorSubject<Array<Pick<AccountsReceivableLedgerEntity,  'Id' | 'MaterialId' | 'Type' | 'Quantity' | 'QuantityTypeId' | 'BookingText' | 'Information' | 'CostAmount' | 'Tax' | 'SupplierId'>>>([]);


    protected commissionOptions$ = this.store.select(getCommissions);

    @Input() set arls(v: Array<Pick<AccountsReceivableLedgerEntity,  'Id' | 'MaterialId' | 'Type' | 'Quantity' | 'QuantityTypeId' | 'BookingText' | 'Information' | 'CostAmount' | 'Tax' | 'SupplierId'>>) {
        this.arls$.next(v);
    }
    @Input() set commissionId(id: number | null) {
        if (id) {
            firstValueFrom(this.store.select(getCommissionById({ id }))).then((commission) => {
                this.commissionForm.setValue(commission);
            });
        } else {
            this.commissionForm.setValue(null);
        }
    }
    @Input() rootLedgerImportId: number;
    @Input() documentType: LedgerImportDocumentTypes.Order | LedgerImportDocumentTypes.DeliveryNote;
    private activeOrderStates = [LedgerImportStatusEnum.Neu, LedgerImportStatusEnum.Versandt];
    protected commissionLabel$ = this.cls.getSingle$('Commission');
    protected supplierLabel$ = this.cls.getSingle$('Supplier');
    protected suppliersLabel$ = this.cls.getMultiple$('Supplier');
    protected materialToSupplier$: Observable<MaterialToSupplierEntity[]> = this.arls$.pipe(
        map((arls) =>
            arls
                ?.filter((arl) => arl.Type === AccountsReceivableLedgerTypeEnum.MaterialArl && arl.MaterialId)
                .map((arl) => arl.MaterialId),
        ),
        switchMap((materialIds) =>
            materialIds?.length
                ? this.materialToSupplierDataService$.getMaterialToSupplierByMaterialIds$(materialIds.sort())
                : of([] as MaterialToSupplierEntity[]),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );


    protected allowedSupplierIds$: Observable<number[]> = this.materialToSupplier$.pipe(
        map((m2s) => [...new Set(m2s.map((m) => m.SupplierId))]),
    );

    protected allowedSuppliers$: Observable<CustomerEntity[]> = this.allowedSupplierIds$.pipe(
        switchMap((ids) => (ids.length ? this.customerDataService.GetCustomers$(ids) : of([]))),
    );

    protected supplierSearchTerm$ = new BehaviorSubject<string>('');

    activeOrderStateString: string = this.activeOrderStates.map((state) => LedgerImportStatusNames.get(state)).join(' oder ');
    protected customerSearch: CustomerSearchState = this.customerDataService.createSearchState({ onlySuppliers: true });
    protected supplierLable: string = '';
    constructor(
        @Inject(MAT_LEGACY_DIALOG_DATA) dialogData: NewOrderFromLedgerimportDialogData,
        private store: Store<State>,
        private actions$: Actions,
        public ls: LoadingService,
        private router: Router,
        private matDialogRef: MatLegacyDialogRef<NewOrderFromLedgerimportComponent, NewOrderFromLedgerimportDialogReturnData>,
        private dialog: MatLegacyDialog,
        protected cls: CustomLabelService,
        protected arlDataService: ArlDataService,
        private customerDataService: CustomerDataService,
    ) {
        this.supplierLabel$.pipe(take(1)).subscribe((sl) => {
            this.supplierLable = sl;
        });

        if (dialogData?.arls) {
            this.arls = dialogData.arls;
        }
        if (dialogData?.rootLedgerImportId) {
            this.rootLedgerImportId = dialogData.rootLedgerImportId;
        }
        if (dialogData?.documentType) {
            this.documentType = dialogData.documentType;
        }
        if (dialogData?.commissionId) {
            this.commissionId = dialogData.commissionId;
        }
        this.dataSource = new NewOrderFromLedgerimportDataSource(
            this.arls$,
            this.supplierForm.valueChanges.pipe(
                startWith(null),
                map(() => this.supplierForm.value?.Id),
            ),
            this.commissionForm.valueChanges.pipe(
                startWith(null),
                map(() => this.commissionForm.value?.Id),
            ),
            this.store,
            this.activeOrderStates,
            this.arlDataService,
            this.documentType
        );
        this.FilterAmount$ = this.dataSource.arlFilterValues$.pipe(
            map((filter) => {
                let amount = 0;
                if (filter[FilterTypes.ArlType]?.length) {
                    amount += 1;
                }
                return amount;
            }),
        );
        this.isAllSelected$ = combineLatest([
            this.dataSource.filteredDataLength$,
            this.materialSelection.changed.pipe(
                startWith(null),
                map(() => this.materialSelection.selected.length),
            ),
        ]).pipe(
            map(([length, lengthSelected]) => length === lengthSelected && length > 0),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
    }

    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.table.dataSource = this.dataSource;
    }
    ngOnDestroy(): void {
        this.dataSource.arlFilterValues$.complete();
    }

    async submit(priceFromM2SOrMaterial: boolean) {
        const loadingKey = 'newOrderFromLedgerimport_submit';
        this.ls.startLoading(loadingKey);
        const rootArl = await firstValueFrom(this.store.select(getLedgerImportById({id: this.rootLedgerImportId})))
        this.store.dispatch(
            LedgerImportActionTypes.CreateLedgerImportFromLedgerImport({
                Payload: {
                    documentType: this.documentType,
                    rootId: this.rootLedgerImportId,
                    customerId: this.supplierForm.value?.Id ?? rootArl?.CustomerId ?? undefined,
                    commissionId: this.commissionForm.value?.Id || undefined,
                    arlPosts: await Promise.all(
                        this.materialSelection.selected.map<Promise<AccountsReceivableLedgerPostType>>(async (row) => {
                            const bookingText = await firstValueFrom(row.bookingText$);
                            const costAmountFromMaterialToSupplierOrMaterial = await firstValueFrom(row.costAmountFromMaterialToSupplierOrMaterialAsNumber$);
                            const cost = priceFromM2SOrMaterial ? costAmountFromMaterialToSupplierOrMaterial || 0 : row.CostAmount || 0;
                            const ret: AccountsReceivableLedgerPostType = {
                                 // amount: CalcAccountsReceivableLedgerAmount(arl.form.value.Quantity || 0, defaultVat, arl.getBaseCost() || 0),
                                 itemNumber: AccountsReceivableLedgerEntity.autogenerateItemNumber,
                                 costAmount: cost,
                                 baseCost: cost,
                                 // fix vor price in resulting LV Calculation, todo bestellungen sollen keine LVs sein
                                 lVSoEk: rootArl.IsLVCalculated ? cost : 0,
                                 tax: row.Tax || 0,
                                 baseCostGross: financialRound(cost * ((row.Tax || 0) / 100 + 1)),
                                 lohnBaseCostPart: 0,
                                 quantity: row.quantityForm.value || 0,
                                 quantityTypeId: row.QuantityTypeId,
                                 information: row.Information,
                                 bookingText,
                                 // ledgerImportId: li.Id,
                                 multiplikator: 1,
                                 isVisible: true,
                                 type: row.Type as AccountsReceivableLedgerTypeEnum,
                                 materialId: row.materialId || null,
                                 supplierId: row.Type === AccountsReceivableLedgerTypeEnum.MaterialArl ? (this.supplierForm.value?.Id ? this.supplierForm.value.Id : row.supplierForm.value?.Id) : null,
                            };
                            return ret;
                        }),
                    ),
                },
            }),
        );

        const liAction = await firstValueFrom(this.actions$.pipe(ofType(LedgerImportActionTypes.CreateLedgerImportFromLedgerImportSuccess, BaseActionTypes.ErrorAction)));
        if (liAction.type === LedgerImportActionTypes.CreateLedgerImportFromLedgerImportSuccess.type && liAction.Payload instanceof LedgerImportEntity) {
            this.materialSelection.clear();
            this.ls.endLoading(loadingKey);
            return liAction.Payload;
        }
        this.ls.endLoading(loadingKey);
        return undefined;
    }
    async confirmCreateNewOrder() {
        const priceType = await firstValueFrom(
            this.dialog
                .open<NewOrderConfirmDialogComponent, NewOrderConfirmDialogData, NewOrderConfirmDialogReturnData>(NewOrderConfirmDialogComponent, {
                    ...NewOrderConfirmDialogComponent.DefaultConfig,
                    data: {
                        supplierName: this.supplierForm.value?.DisplayName || null,
                        commissionName: this.commissionForm.value?.DisplayName || null,
                        documentTypeName: LedgerImportDocumentTypeNames.get(this.documentType),
                    },
                })
                .afterClosed(),
        );
        return priceType;
    }
    async onSubmitClick() {
        const priceType = await this.confirmCreateNewOrder();
        if (priceType) {
            await this.submit(priceType === NewOrderConfirmDialogPriceType.costFromM2s);
        }
    }

    async onSubmitAndRouteClick() {
        const priceType = await this.confirmCreateNewOrder();
        if (priceType) {
            const li = await this.submit(priceType === NewOrderConfirmDialogPriceType.costFromM2s);
            if (li) {
                this.router.navigate(['/', ReportsPageMeta.Path, AllReportsMeta.Path,  li.Id]);
                this.matDialogRef?.close();
            }
        }
    }

    compareById(p1: SelectSearchOption<{ Id: number }>, p2: SelectSearchOption<{ Id: number }>) {
        return p1?.Id === p2?.Id;
    }
    async toggleAllRows() {
        const allSelected = await firstValueFrom(this.isAllSelected$);
        if (allSelected) {
            this.materialSelection.clear();
        } else {
            const data = await firstValueFrom(this.dataSource.filteredData$ || this.dataSource.data$);
            data.forEach((row) => this.materialSelection.select(row));
        }
    }

    onPriceInformationClick(row: NewOrderFromLedgerimportItem) {
        const dialogRef = this.dialog
            .open<MaterialPriceDetailsPopupComponent, MaterialPriceDetailsPopupComponentDialogData, MaterialPriceDetailsPopupComponentDialogReturnData>(MaterialPriceDetailsPopupComponent, {
                ...MaterialPriceDetailsPopupComponent.DefaultConfig,
                data: {
                    materialId: row.materialId,
                    supplierId: row.supplierForm.value?.Id,
                    ledgerImportDocumentType: this.documentType,
                    showOtherSuppliersList: true,
                    showAcceptPriceButton: true,
                },
            });
        dialogRef.componentInstance.M2SChange.pipe(takeUntil(dialogRef.afterClosed())).subscribe((m2s) => {
            firstValueFrom(this.customerDataService.GetSingleCustomer$(m2s.SupplierId)).then((customer) => {
                row.supplierForm.setValue(customer);
                row.supplierForm.markAsDirty();
            });
        })
        // dialogRef.afterClosed()
        //     .subscribe((customerId: number) => {
        //         if (customerId) {
        //             firstValueFrom(this.store.select(getCustomerById({ id: customerId }))).then((result) => {
        //                 row.supplierForm.setValue(result);
        //                 row.supplierForm.markAsDirty();
        //             });
        //         }
        //     });
    }

    protected readonly LedgerImportDocumentTypes = LedgerImportDocumentTypes;

    protected customerCompareOptions = (a, b) => a?.Id === b?.Id;
    protected customerpageChange = (event) => this.customerSearch.customerPageChange(event);
    protected filteredSupplierOptions$: Observable<SelectSearchOption<CustomerEntity>[]> = combineLatest([
        this.allowedSuppliers$,
        this.supplierSearchTerm$,
    ]).pipe(
        map(([suppliers, term]) =>
            suppliers
                .filter((s) => !term || getCustomerOptionLabel(s).toLowerCase().includes(term.toLowerCase()))
                .map((s) => withOptionLabel(s, getCustomerOptionLabel(s))),
        ),
    );

    protected customerserverSearch = (search: string) => this.supplierSearchTerm$.next(search);

    get documentLabel(): string {
        return this.documentType === LedgerImportDocumentTypes.Order
            ? 'Bestellt'
            : 'Geliefert';
    }

    get documentPluralLabel(): string {
        return this.documentType === LedgerImportDocumentTypes.Order
            ? 'Bestellungen'
            : 'Lieferungen';
    }

    get documentTitle(): string {
        return this.documentType === LedgerImportDocumentTypes.Order
            ? 'Bestellung erzeugen'
            : 'Lieferschein erzeugen';
    }

    get documentQuantityLable(): string {
        return this.documentType === LedgerImportDocumentTypes.Order
            ? 'Bestellmenge (Ist)'
            : 'Liefermenge (Ist)';
    }
}
